import { useEffect, useState } from 'react';
import { IApiResponse, useFetch } from '../Utils/hooks/useFetch';

export interface CustomerTag {
  id: number;
  attributes: {
    name: string;
    customers: { data: unknown[] };
  };
}

const sortTags = (array: CustomerTag[]) =>
  array?.sort(
    (a, b) => b.attributes.customers.data.length - a.attributes.customers.data.length
  );

export const useCustomerTags = () => {
  const [techTags, setTechTags] = useState<CustomerTag[]>([]);
  const [businessTags, setBusinessTags] = useState<CustomerTag[]>([]);
  const [techTagsError, setTechTagsError] = useState(false);
  const [businessTagsError, setBusinessTagsError] = useState(false);
  const [techTagsLoading, setTechTagsLoading] = useState(false);
  const [businessTagsLoading, setBusinessTagsLoading] = useState(false);

  const {
    data: customerTechTagsFirst,
    loading: firstTechTagsLoading,
    error: firstTechTagsError,
  }: IApiResponse = useFetch(
    'customer-tech-tags?pagination[page]=1&pagination[pageSize]=100&&populate=*'
  );

  const {
    data: customerTechTagsSecond,
    loading: secondTechTagsLoading,
    error: secondTechTagsError,
  }: IApiResponse = useFetch(
    'customer-tech-tags?pagination[start]=101&pagination[limit]=100&&populate=*'
  );

  const {
    data: customerBusinessTagsFirst,
    loading: businessTagsLoadingFirst,
    error: businessTagsErrorFirst,
  }: IApiResponse = useFetch(
    'customer-business-tags?pagination[start]=0&pagination[limit]=100&&populate=*'
  );

  const {
    data: customerBusinessTagsSecond,
    loading: businessTagsLoadingSecond,
    error: businessTagsErrorSecond,
  }: IApiResponse = useFetch(
    'customer-business-tags?pagination[start]=101&pagination[limit]=100&&populate=*'
  );

  useEffect(() => {
    if (customerTechTagsFirst && customerTechTagsSecond) {
      setTechTagsLoading(false);
      const technologyTags = [...customerTechTagsFirst];
      if (technologyTags.length) {
        const sorted = sortTags(technologyTags as CustomerTag[]);
        sorted.length = 25;
        setTechTags(sorted);
      }
    }
  }, [customerTechTagsFirst, customerTechTagsSecond]);

  useEffect(() => {
    if (customerBusinessTagsFirst && customerBusinessTagsSecond) {
      setBusinessTagsLoading(false);
      const industryTags = [...customerBusinessTagsFirst, ...customerBusinessTagsSecond];
      if (industryTags.length) {
        const sorted = sortTags(industryTags as CustomerTag[]);
        sorted.length = 25;
        setBusinessTags(sorted);
      }
    }
  }, [customerBusinessTagsFirst, customerBusinessTagsSecond]);

  useEffect(() => {
    if (firstTechTagsLoading && secondTechTagsLoading) {
      setTechTagsLoading(true);
      setTechTagsError(false);
    }
  }, [firstTechTagsLoading, secondTechTagsLoading]);

  useEffect(() => {
    if (businessTagsLoadingFirst && businessTagsLoadingSecond) {
      setBusinessTagsLoading(true);
    }
  }, [businessTagsLoadingFirst, businessTagsLoadingSecond]);

  useEffect(() => {
    if (firstTechTagsError || secondTechTagsError) {
      setTechTagsError(true);
      setTechTagsLoading(false);
    }
  }, [firstTechTagsError, secondTechTagsError]);

  useEffect(() => {
    if (businessTagsErrorFirst || businessTagsErrorSecond) {
      setBusinessTagsError(true);
      setBusinessTagsLoading(false);
    }
  }, [businessTagsErrorFirst, businessTagsErrorSecond]);

  return {
    techTags,
    businessTags,
    techTagsLoading,
    businessTagsLoading,
    techTagsError,
    businessTagsError,
  };
};
